exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services{width:90%;margin:0 auto}.services .table{width:100%}.services .table .sorting{background-image:url(\"/images/sort_both.png\");background-repeat:no-repeat;background-position:100%}.services .table .sorting_asc{background-image:url(\"/images/sort_asc.png\");background-repeat:no-repeat;background-position:100%}.services .table .sorting_desc{background-image:url(\"/images/sort_desc.png\");background-repeat:no-repeat;background-position:100%}h1{text-align:center;font-size:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-270cd9a3","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/Item/Services.vue
// module id = VO9g
// module chunks = 0